import { gql } from "@apollo/client";

export const GET_MODERATOR_AVAILABLE_COUNT = gql`
  query GetModeratorAvailableCount($educationLevel: ID!, $subject: ID!) {
    moderatorAvailableCount(educationLevel: $educationLevel, subject: $subject)
  }
`;

export const GET_MODERATOR_ANSWER = gql`
  query GetModeratorAnswer($answer: ID!) {
    anonymousAnswer(answer: $answer) {
      id
      answer
      status
      submittedAt
      question {
        id
        questionText
        questionType
        educationLevel {
          id
          name: level
        }
        subject {
          id
          name
        }
        sourceText
        sourceImages {
          id
          fileUrl
          description
        }
        markScheme {
          id
          modelAnswerGuidance
          objectives {
            id
            marks
            assessmentObjective {
              id
              identifier
              description
              focusArea
            }
            levels {
              id
              minMark
              maxMark
              levelCriteria
            }
          }
        }
      }
      assignment {
        id
        name
        dueDate
        schoolClass {
          id
          name
        }
      }
      automatedFeedback {
        id
        mark
        feedback
        specificAreasOfImprovement
        spellingAndGrammar {
          id
          reasoning
          mistake {
            incorrectSpelling
            correctSpelling
          }
          locations {
            startIndex
            endIndex
          }
        }
        assessmentObjectiveFeedback {
          id
          mark
          availableMarks
          assessmentObjective {
            id
            identifier
            focusArea
          }
          assessmentObjectiveEvidence {
            id
            evidence
            reasoning
            feedback
            locations {
              id
              startIndex
              endIndex
            }
          }
        }
      }
      moderatorFeedback {
        id
        mark
        feedback
        specificAreasOfImprovement
        approvedBy {
          id
          firstName
          lastName
        }
        approvedAt
        spellingAndGrammar {
          id
          reasoning
          mistake {
            incorrectSpelling
            correctSpelling
          }
          locations {
            startIndex
            endIndex
          }
        }
        assessmentObjectiveFeedback {
          id
          mark
          availableMarks
          assessmentObjective {
            id
            identifier
            focusArea
          }
          assessmentObjectiveEvidence {
            id
            evidence
            reasoning
            feedback
            locations {
              id
              startIndex
              endIndex
            }
          }
        }
      }
      student {
        ... on StudentNode {
          id
          firstName
          lastName
        }
        ... on StudentIdentifierNode {
          id
          identifier
        }
      }
    }
  }
`;

export const GET_NEXT_MODERATOR_ANSWER = gql`
  query GetNextModeratorAnswer(
    $educationLevel: ID!
    $subject: ID!
    $currentAnswer: ID
  ) {
    nextModeratorAnswer(
      educationLevel: $educationLevel
      subject: $subject
      currentAnswer: $currentAnswer
    ) {
      id
      answer
      status
      submittedAt
      question {
        id
        questionText
        questionType
        educationLevel {
          id
          name: level
        }
        subject {
          id
          name
        }
        sourceText
        sourceImages {
          id
          fileUrl
          description
        }
        markScheme {
          id
          modelAnswerGuidance
          objectives {
            id
            marks
            assessmentObjective {
              id
              identifier
              description
              focusArea
            }
            levels {
              id
              minMark
              maxMark
              levelCriteria
            }
          }
        }
      }
      assignment {
        id
        name
        dueDate
        schoolClass {
          id
          name
        }
      }
      automatedFeedback {
        id
        mark
        feedback
        specificAreasOfImprovement
        spellingAndGrammar {
          id
          reasoning
          mistake {
            incorrectSpelling
            correctSpelling
          }
          locations {
            startIndex
            endIndex
          }
        }
        assessmentObjectiveFeedback {
          id
          mark
          availableMarks
          assessmentObjective {
            id
            identifier
            focusArea
          }
          assessmentObjectiveEvidence {
            id
            evidence
            reasoning
            feedback
            locations {
              id
              startIndex
              endIndex
            }
          }
        }
      }
      moderatorFeedback {
        id
        mark
        feedback
        specificAreasOfImprovement
        approvedBy {
          id
          firstName
          lastName
        }
        approvedAt
        spellingAndGrammar {
          id
          reasoning
          mistake {
            incorrectSpelling
            correctSpelling
          }
          locations {
            startIndex
            endIndex
          }
        }
        assessmentObjectiveFeedback {
          id
          mark
          availableMarks
          assessmentObjective {
            id
            identifier
            focusArea
          }
          assessmentObjectiveEvidence {
            id
            evidence
            reasoning
            feedback
            locations {
              id
              startIndex
              endIndex
            }
          }
        }
      }
      student {
        ... on StudentNode {
          id
          firstName
          lastName
        }
        ... on StudentIdentifierNode {
          id
          identifier
        }
      }
    }
  }
`;

export const GET_MODERATED_ANSWERS = gql`
  query GetModeratedAnswers($educationLevel: ID, $subject: ID) {
    moderatedAnswers(educationLevel: $educationLevel, subject: $subject) {
      id
      submittedAt
      answer
      question {
        id
        questionText
        subject {
          id
          name
        }
        educationLevel {
          id
          name: level
        }
      }
      assignment {
        id
        name
      }
      moderatorFeedback {
        id
        mark
        approvedAt
      }
      student {
        ... on StudentNode {
          id
          firstName
          lastName
        }
        ... on StudentIdentifierNode {
          id
          identifier
        }
      }
    }
  }
`;
